var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.loading)?_c('loading'):_c('router-view'),_vm._l((_vm.$root.errors),function(error){return _c('p',[_vm._v(_vm._s(error.message))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }